export const REGISTRATION_PLAN_SELECTED_EVENT = 'acompanha:registration-plan-selected';

export function dispatchRegistrationPlanSelected(plan) {
    window.dispatchEvent(new CustomEvent(REGISTRATION_PLAN_SELECTED_EVENT, { detail: plan }));
}

export function planRegistrationActionLabel(plan) {
    if (!plan || plan.isFree) {
        return 'Começar grátis';
    }
    return `Escolher ${plan.name}`;
}
